import _ from 'lodash';

const getActiveSublayersByLayerId = (state) => (layerId) => {
  return _.filter(state.layers, {
    isActive: 1,
    parentId: layerId
  });
};

const getCanAddPinLayers = (state) => {
  return _.filter(state.layers, {
    // isActive: 1,
    canAddIndividualPin: 1
  });
};

export default {
  getActiveSublayersByLayerId,
  getCanAddPinLayers
};
